import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const engagementRateConfig = {
    name: 'kpi.instagram.engagement_rate',
    id: 'post_engagements',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_25,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault
};
